<template>
  <transition name="fade">
    <div class="vote-dialog" v-show="visible" @click.self="handleClose">
      <div class="dialog-content">
        <Icon type="md-close" class="close-icon" @click="handleClose"></Icon>

        <div class="dialog-title">扫码进入投票专区</div>

        <div class="dialog-desc">
          <div class="desc-line">扫描下方二维码，进入手机端</div>
          <div class="desc-line">即可浏览完整作品详情、提交投票</div>
        </div>

        <div class="qrcode-box">
          <img :src="qrcodeUrl | default_img" class="qrcode-img" alt="投票二维码" />
        </div>

        <div class="dialog-tip">微信扫码 立即投票</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'VoteDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    qrcodeUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.vote-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog-content {
    background: linear-gradient(0deg, #FFFFFF 0%, #FFFFFF 50%, #FFE9E9 100%);
    border-radius: 10px;
    position: relative;
    width: 360px;
    height: 357px;
    padding: 40px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .close-icon {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 24px;
      cursor: pointer;
      color: #999;
      z-index: 10;
      transition: color 0.3s;

      &:hover {
        color: #666;
      }
    }

    .dialog-title {
      font-weight: bold;
      font-size: 18px;
      line-height: 27px;
      color: #333333;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .dialog-desc {
      width: 100%;
      margin-top: 6px;

      .desc-line {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        text-align: center;
        font-style: normal;
        text-transform: none;

        &:last-child {
          width: 100%;
        }
      }
    }

    .qrcode-box {
      width: 166px;
      height: 166px;
      margin-top: 16px;
      border-radius: 50%;

      .qrcode-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .dialog-tip {
      margin-top: 16px;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #999999;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }
}

// 动画效果
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>